export default __webpack_public_path__ + "static/media/11.a4000487.jpeg";